import React, { useEffect, useState } from 'react'

import { CSVLink } from 'react-csv'

import Modal from '../../components/UI/UIModal'
import UiSelect from '../../components/UI/UISelect'
import { Icon } from '../../components/Icon'
import { TrackingHeader } from '../../data/index'
// import Pagination from '../../components/UI/Pagination'
import UIButton from '../../components/UI/UIButton'
import '../../App.css'
import { useQuery } from 'react-query'
import { getTrackingData } from './apiCalls'
import Loading from '../../components/UI/Loading'

import { formatDate } from '../../utils/utils'
import {
  // calculatePageCount,
  exportToExcel,
  handleDownloadHtml,
  handleDownloadTxt,
} from './utils'
import UIMultiSelect from '../../components/UI/UIMultiSelect'
import { UIExportHtmlTable } from '../../components/UI/UIExportHtmlTable'
import { toast } from 'react-toastify'

interface TrackingHeaderInterface {
  Username: string
  'First Name': string
  'Last Name': string
  'Policy Name': string
  Email: string
  'Agreements Updated': string
}

const Tracking = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [isConfrim, setIsConfrim] = useState<boolean>(false)
  // const [currentPage, setCurrentPage] = useState<number>(1)
  const [fileType, setFileType] = useState<string>('')
  const [fileHeader] = useState([
    { key: 'Username', label: 'Username' },
    { key: 'First_Name', label: 'First Name' },
    { key: 'Last_Name', label: 'Last Name' },
    { key: 'Policy_Name', label: 'Policy Name' },
    { key: 'Email', label: 'Email' },
    { key: 'Agreements_Updated', label: 'Agreements_Updated' },
  ])
  const [sortOrder, setSortOrder] = useState<{
    [key: string]: 'asc' | 'desc'
  }>({})
  const [sortBy, setSortBy] = useState<string>('userName')
  const [sortOrderValue, setSortOrderValue] = useState<string>('asc')

  const tracking = useQuery('policy', () =>
    getTrackingData(
      // currentPage,
      sortBy,
      sortOrderValue
    )
  )

  const handleSort = (key: string) => {
    const newSortOrder = { ...sortOrder }
    //  console.log(' newSortOrder[key]', key)
    if (newSortOrder[key] === 'asc' || newSortOrder[key] === undefined) {
      //  console.log(' newSortOrder[testjdjsn]', newSortOrder[key])
      newSortOrder[key] = 'desc'
      setSortBy(key)
      setSortOrderValue('desc')
    } else {
      newSortOrder[key] = 'asc'
      setSortBy(key)
      setSortOrderValue('asc')
    }
    setSortOrder(newSortOrder)
  }

  useEffect(() => {
    tracking.refetch() // Refetch incidents when sortBy or sortOrderValue changes
  }, [sortBy, sortOrderValue])

  const handleExportCloseModal = () => {
    setIsOpen(false)
  }

  // const handlePageChange = (pageNumber: number): void => {
  //   setCurrentPage(pageNumber)
  //   // You can add additional logic here, like fetching data for the new page
  // }

  const handleOpenModal = () => {
    setIsOpen(true)
  }

  // useEffect(() => {
  //   tracking.refetch()
  // }, [currentPage])

  const columns = [
    {
      title: 'User Name',
      column: 'userName',
    },
    {
      title: 'First Name',
      column: 'firstName',
    },
    {
      title: 'Last Name',
      column: 'lastName',
    },
    {
      title: 'Policy Name',
      column: 'policyName',
    },
    {
      title: 'Email',
      column: 'email',
    },
    {
      title: 'Agreements Updated',
      column: 'createdAt',
    },
  ]

  return (
    <div
      className={
        'flex flex-col gap-6 w-full bg-white  h-full rounded-3xl p-8   relative'
      }
    >
      <div className={'flex w-full justify-between items-start '}>
        <div className="flex-col w-[50%] gap-5">
          <p className={'text-[18px] text-text2 font-bold '}>Tracking</p>
          {/* <p
            className={'text-[14px] font-normal text-text1 leading-[24px] mt-2'}
          >
            Please use the export button to download client agreements: To
            export these results, select which columns you’d like and then
            choose a file format to export.
          </p> */}
        </div>

        <div className={'flex flex-row gap-[15px]'}>
          <div
            onClick={() => {
              if (tracking?.data?.data?.length != 0) {
                handleOpenModal()
              } else {
                toast.info('No data available.', {
                  position: 'top-right',
                })
              }
            }}
            className="gap-[10px]  bg-bluishGreen items-center justify-between min-w-[95px] text-white h-12 px-[20px] flex rounded-[72px] cursor-pointer"
          >
            <p className={'font-semibold text-sm leading-6 text-white'}>
              Export Data
            </p>
            <Icon
              name={'IconShare'}
              strokeWidth={1.2}
              stroke={'white'}
              width={16}
              height={16}
            />
          </div>
        </div>
      </div>
      {/* content container */}
      <div className="relative h-full overflow-y-auto">
        <div className=" max-h-full h-full overflow-y-auto">
          {tracking.isLoading && (
            <div className="flex-col  w-[100%] p-[10px]">
              <Loading size="large" />
            </div>
          )}

          {!tracking.isLoading && (
            <table className="min-w-full table-auto divide-y-4 divide-white">
              <thead className="sticky top-0 z-10 mb-4">
                <tr className="bg-gray2 rounded-lg h-10 mb-18">
                  {TrackingHeader?.map((item: string, index: number) => {
                    return (
                      <th
                        key={index}
                        className={`px-4 py-3 text-left ${index === 0 ? 'rounded-l-lg' : ''} ${index === TrackingHeader.length - 1 ? 'rounded-r-lg' : ''} ${index === TrackingHeader.length - 1 ? 'border-none' : 'border-r border-white'}`}
                      >
                        <div className="flex items-center">
                          <p className="text-text1 font-semibold text-sm flex-1">
                            {item}
                          </p>
                          <div
                            className="cursor-pointer"
                            onClick={() => {
                              let sortBy = ''
                              switch (item as keyof TrackingHeaderInterface) {
                                case 'Username':
                                  sortBy = 'userName'
                                  break
                                case 'First Name':
                                  sortBy = 'firstName'
                                  break
                                case 'Last Name':
                                  sortBy = 'lastName'
                                  break
                                case 'Policy Name':
                                  sortBy = 'title'
                                  break
                                case 'Email':
                                  sortBy = 'email'
                                  break
                                case 'Agreements Updated':
                                  sortBy = 'createdAt'
                                  break
                                default:
                                  break
                              }
                              // console.log('valueeyyyyyyyyy--->', sortBy)
                              handleSort(sortBy)
                            }}
                          >
                            <Icon
                              name={'IconChevronDown'}
                              width={16}
                              height={16}
                              strokeWidth={1}
                              stroke={'#67A5B9'}
                            />
                          </div>
                        </div>
                      </th>
                    )
                  })}
                </tr>
              </thead>
              <tbody>
                {tracking?.data?.data?.map((item, index) => (
                  <>
                    <tr key={index} className="bg-gray1">
                      {/* Example row */}

                      <td className="px-4 font-medium text-textError text-[12px] h-[48px] py-2 border border-white">
                        <p className="flex-1 text-sm text-text1 leading-6 font-semibold">
                          {item.firstName}
                        </p>
                      </td>
                      <td className="px-4 font-medium text-textError text-[12px] h-[48px] py-2 border border-white">
                        <p className="flex-1 text-sm text-text1 leading-6 font-semibold">
                          {item.lastName}
                        </p>
                      </td>
                      <td className="px-4 font-medium text-textError text-[12px] h-[48px] py-2 border border-white">
                        <p className="flex-1 text-sm text-text1 leading-6 font-semibold">
                          {item.title}
                        </p>
                      </td>
                      <td className="px-4 font-medium text-textError text-[12px] h-[48px] py-2 border border-white">
                        <p className="flex-1 text-sm text-text1 leading-6 font-semibold">
                          {item.email}
                        </p>
                      </td>
                      <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                        <p className="flex-1 text-sm text-text1 leading-6 font-semibold">
                          {formatDate(item.createdAt)}
                        </p>
                      </td>
                    </tr>
                  </>
                ))}
              </tbody>
            </table>
          )}
          {/* <div className="absolute bottom-[30px] left-[15px]">
            <Pagination
              currentPage={currentPage}
              totalPages={calculatePageCount(
                Number(tracking?.data?.count) || 0
              )}
              onPageChange={handlePageChange}
            />
          </div> */}
        </div>
      </div>

      <Modal
        customStyle={{ borderRadius: 16, padding: '16px 8px', width: '480px' }}
        isOpen={isOpen}
        onClose={handleExportCloseModal}
      >
        {isConfrim ? (
          <div
            className={
              'max-h-[100vh] overflow-scroll custom-scrollbar items-center flex flex-col gap-4 py-4 px-8'
            }
          >
            <div
              onClick={handleExportCloseModal}
              className="flex w-[100%] justify-end cursor-pointer"
            >
              <Icon
                name={'IconCross'}
                stroke="#02698C"
                height={16}
                width={16}
              />
            </div>
            <div className="flex items-center w-[100%] justify-center">
              <Icon
                name={'IconExportData'}
                height={52}
                width={52}
                strokeWidth={1}
                stroke="#02698C"
              />
            </div>
            <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
              <h1 className={'text-text2 text-lg font-bold leading-6'}>
                Export Data
              </h1>
              <p
                className={
                  'text-sm text-text1 font-normal leading-6 text-center'
                }
              >
                The CSV export file will be generated for download. Disable any
                popup blockers in your browser to ensure proper download.{' '}
                <span className="mt-3">Ok to proceed?</span>
              </p>
              <p
                className={
                  'text-sm text-text1 font-normal leading-6 mt-4 text-center'
                }
              >
                Ok to proceed?
              </p>
            </div>
            <div className="w-full flex flex-col gap-2 mt-2">
              {(fileType == 'Excel95' || fileType == 'Excel2007') && (
                <UIButton
                  label="Confirm"
                  onClick={() => {
                    exportToExcel(tracking?.data?.data, 'data', fileType)
                    handleExportCloseModal()
                    setIsConfrim(!isConfrim)
                  }}
                />
              )}
              {fileType == 'HTML' && (
                <UIButton
                  label="Confirm"
                  onClick={() => {
                    const html = UIExportHtmlTable({
                      columns: columns,
                      data: tracking?.data?.data || [],
                    })
                    if (html) {
                      handleDownloadHtml(html)
                      handleExportCloseModal()
                      setIsConfrim(!isConfrim)
                    }
                  }}
                />
              )}
              {fileType == 'Text' && (
                <UIButton
                  label="Confirm"
                  onClick={() => {
                    handleDownloadTxt(tracking?.data?.data)
                    handleExportCloseModal()
                    setIsConfrim(!isConfrim)
                  }}
                />
              )}
              {fileType == 'CSV' && (
                <CSVLink
                  target="_blank"
                  filename={'data.csv'}
                  headers={fileHeader}
                  data={
                    tracking?.data?.data?.map((item) => ({
                      Username: item.userName,
                      First_Name: item.firstName,
                      Last_Name: item.lastName,
                      Policy_Name: item.title,
                      Email: item.email,
                      Agreements_Updated: item?.createdAt,
                    })) || []
                  }
                >
                  <UIButton
                    label="Confirm"
                    onClick={() => {
                      handleExportCloseModal()
                      setIsConfrim(!isConfrim)
                    }}
                  />
                </CSVLink>
              )}
              <UIButton
                secondary
                label="Cancel"
                onClick={() => setIsConfrim(!isConfrim)}
              />
            </div>
          </div>
        ) : (
          <div
            className={
              'max-h-[100vh] overflow-scroll items-center p-4 flex flex-col gap-4'
            }
          >
            <div
              onClick={handleExportCloseModal}
              className="flex w-[100%] justify-end cursor-pointer"
            >
              <Icon
                name={'IconCross'}
                stroke="#02698C"
                height={16}
                width={16}
              />
            </div>
            <div className="flex items-center w-[100%] justify-center">
              <Icon
                name={'IconExportData'}
                height={52}
                width={52}
                strokeWidth={1}
                stroke="#02698C"
              />
            </div>
            <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
              <h1 className={'text-text2 text-[18px] font-bold'}>
                Export Data
              </h1>
              <p className={'text-[14px] text-text1 font-normal'}>
                Please choose the data you want to export and file type.
              </p>
            </div>
            <div className="w-[420px] flex-col flex gap-4 my-[15px]">
              <UIMultiSelect
                options={[
                  { value: 'Username', label: 'Username' },
                  { value: 'First_Name', label: 'First Name' },
                  { value: 'Last_Name', label: 'Last Name' },
                  { value: 'Policy_Name', label: 'Policy Name' },
                  { value: 'Email', label: 'Email' },
                  { value: 'Agreements_Updated', label: 'Agreements_Updated' },
                ]}
                title={'Select Export Columns'}
              />
              <UiSelect
                title={'Choose Filetype'}
                placeholder="Please specify"
                labelClass={'text-xs'}
                onChange={(value) => setFileType(value)}
                selectedOptionClass={
                  'text-sm font-semibold leading-6 text-text4'
                }
                options={[
                  {
                    value: 'HTML',
                    label: 'HTML',
                    iconName: 'IconGlobe',
                  },
                  {
                    value: 'CSV',
                    label: 'CSV',
                    iconName: 'IconCodeSquare',
                  },
                  {
                    value: 'Text',
                    label: 'Text',
                    iconName: 'IconFile',
                  },
                  {
                    value: 'Excel95',
                    label: 'Excel 95 +',
                    iconName: 'IconBarChartCircle',
                  },
                  {
                    value: 'Excel2007',
                    label: 'Excel 2007 +',
                    iconName: 'IconBarChartSquare',
                  },
                ]}
              />
            </div>
            <div className="w-full">
              <button
                onClick={() => {
                  if (
                    fileType == 'CSV' ||
                    fileType == 'Text' ||
                    fileType == 'HTML' ||
                    fileType == 'Excel95' ||
                    fileType == 'Excel2007'
                  )
                    setIsConfrim(!isConfrim)
                }}
                className=" bg-bluishGreen text-white min-h-[48px] w-[98%] font-medium rounded-[72px] text-[14px]  "
              >
                Export Data
              </button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  )
}

export default Tracking
